import { useState } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';

const SmartTableMobileListItem = ({
  index,
  data,
  rowClick,
  columnConfig,
  expandable,
}) => {
  const [isExpanded, setIsExpanded] = useState(!expandable);
  const t = useTranslation();

  const headerColumnConfig = columnConfig
    .filter((col) => col.mobile?.headerPlacement)
    .sort((a, b) => {
      if (a.mobile.headerPlacement === b.mobile.headerPlacement) return 0;
      if (a.mobile.headerPlacement === 'left') return -1;
      if (b.mobile.headerPlacement === 'left') return 1;
      return 0;
    });

  const contentColumnConfig = columnConfig.filter((col) => !col.mobile?.headerPlacement);

  return (
    <div
      onClick={() => rowClick?.(data[index], index)}
      className={`mobile-smart-table-list-item ${expandable ? 'mobile-smart-table-list-item-expandable' : ''} ${isExpanded ? 'mobile-smart-table-list-item-expanded' : ''}`}
    >
      <div className="mobile-smart-table-item-header" onClick={() => setIsExpanded(!isExpanded)}>
        {headerColumnConfig.map((col, colIndex) => (
          // eslint-disable-next-line
          <div key={colIndex} className={`mobile-smart-table-header-${col.mobile.headerPlacement} ${col.mobile.columnClassName || ''}`}>
            {col.row(data, index)}
          </div>
        ))}

        {expandable && (
          <i className={`mobile-smart-table-list-item-toggle-icon global-icon ${isExpanded ? 'icon-thin-arrow-up' : 'icon-thin-arrow-down'}`} />
        )}
      </div>

      {isExpanded && (
        <div className="mobile-smart-table-item-content">
          {contentColumnConfig.map((col, colIndex) => {
            const colName = typeof col.name === 'function'
              ? col.name()
              : t(col.name);

            return (
              // eslint-disable-next-line
              <div key={colIndex} className={`mobile-smart-table-column ${col.mobile?.columnClassName || ''}`}>
                <div className="mobile-smart-table-column-name">{colName}</div>
                <div className="mobile-smart-table-column-value">
                  {col.row(data, index)}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

SmartTableMobileListItem.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  rowClick: PropTypes.func,
  columnConfig: PropTypes.array.isRequired,
  expandable: PropTypes.bool,
};

export default SmartTableMobileListItem;
